export default {
  UAH: 'UAH',
  USD: 'USD',
  EUR: 'EUR',
};
